import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers, getAllBulkUploadUsers, setCustomer } from "../../../store/slices/customers";
import { getAllPrograms } from "../../../store/slices/programsSlice";
import { useNavigate } from "react-router";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { get } from "react-hook-form";
import API from "../../../api/baseApi";
import { getAccessToken } from "../../../api/baseApi";
import * as XLSX from "xlsx";
import { CUSTOMER_FIELDS } from "./customerFields";
import ProgramSlugModal from "../../Common/ProgramSlugModal";
import axios from "axios";
import { useDebounce } from "../../../Hooks/useDebounce";

// import BulkUploadCustomers from "./BulkUploadCustomers";
const CustomersTable = () => {
  // Program slug modal state
  const [showSlugModal, setShowSlugModal] = useState(false);
  // Generic "Programs & Slugs" modal (with copy) shown next to Get Template
  const [programSlugOpen, setProgramSlugOpen] = useState(false);
  const [programList, setProgramList] = useState([]);
  const [csv, setCsv] = useState(null);
  const inputRef = useRef(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const history = useNavigate();
  const id = window.location.pathname.split("/").pop();
  const layout = id;
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setCount] = useState(0);

  // Field mapping states
  const [showMappingModal, setShowMappingModal] = useState(false);
  const [uploadedHeaders, setUploadedHeaders] = useState([]);
  const [fieldMapping, setFieldMapping] = useState({}); // { databaseFieldKey: uploadedHeader }
  const [mappingErrors, setMappingErrors] = useState({});

  const { customers, count } = useSelector(
    (state) => state.customers.customers,
  );
  const client = useSelector((state) => state.clients.selectedClient.value);
  const [isLoading, setIsLoading] = useState(false);
  const permissions = useSelector((state) => state.auth.permissions);
  const userRole = useSelector((state) => state.auth.user.role);
  const [isTemplateDownloadLoading, setIsTemplateDownloadLoading] =
    useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const tenantClientData = useSelector((state) => state.clients);

  const UploadAllowTenant = ["hc", "ebix", "vahan"];
  const SlugNameAllowTenant = ["vahan", "hc"];

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder =
      sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;

    const res = await dispatch(
      getAllCustomers({
        pagination: true,
        limit: pageSize,
        offset: page * pageSize,
        sortBy: sortField,
        sortOrder: sortOrder,
        ...payload,
      }),
    );
    if (res?.payload) {
      const p = res.payload;
      setData(p.customers || p.result || p.data || []);
      setCount(
        p.count !== undefined ? p.count : p.total !== undefined ? p.total : 0,
      );
    }
  };



  useEffect(() => {
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  }, [
    dispatch,
    client,
    page,
    pageSize,
    debouncedSearch,
    columnFilterSearch,
    sorting,
  ]);



  const getCustomers = () => {
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "first_name",
        header: "First Name",
        size: 150,
      },
      {
        accessorKey: "last_name",
        header: "Last Name",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "phone",
        header: "Mobile No.",
        size: 150,
      },
      {
        accessorKey: "address",
        header: "Address",
        size: 150,
      },
      {
        id: "mobile_verify",
        header: "Mobile Verify",
        size: 120,
        Cell: () => <span className="badge badge-success">Verified</span>,
      },
      {
        id: "email_verify",
        header: "Email Verify",
        size: 120,
        Cell: () => <span className="badge badge-success">Verified</span>,
      },
      {
        accessorKey: "is_personal_details_fill",
        header: "Details Filled",
        size: 120,
        Cell: ({ cell }) => (
          <span className={`badge ${cell.getValue() ? 'badge-success' : 'badge-warning'}`}>
            {cell.getValue() ? 'Yes' : 'No'}
          </span>
        ),
      },
      {
        accessorKey: "isActive",
        header: "Account Activated",
        size: 120,
        Cell: ({ cell }) => (
          <span className={`badge ${cell.getValue() ? 'badge-success' : 'badge-secondary'}`}>
            {cell.getValue() ? 'Active' : 'Inactive'}
          </span>
        ),
      },
      {
        accessorKey: "activation_mail_sent",
        header: "Activation Mail Sent",
        size: 140,
        Cell: ({ cell }) => (
          <span className={`badge ${cell.getValue() ? 'badge-success' : 'badge-warning'}`}>
            {cell.getValue() ? 'Yes' : 'No'}
          </span>
        ),
      },
      {
        id: "program_name",
        header: "Enrolled Program",
        size: 200,
        Cell: ({ row }) => {
          const subs = row.original.CustomerSubscription || [];
          return subs[0]?.Programs?.name || 'N/A';
        },
      },
      {
        id: "expiration_date",
        header: "Expiry Date",
        size: 150,
        Cell: ({ row }) => {
          const services = row.original.CustomerServices || [];
          const dateStr = services[0]?.expiration_date;
          return dateStr ? new Date(dateStr).toLocaleDateString() : 'N/A';
        },
      },
    ],
    [],
  );

  const bulkColumns = useMemo(
    () => [
      {
        accessorKey: "first_name",
        header: "First Name",
        size: 150,
      },
      {
        accessorKey: "last_name",
        header: "Last Name",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "phone",
        header: "Mobile No.",
        size: 150,
      },
      {
        accessorKey: "uniqueRegID",
        header: "Unique Reg ID",
        size: 150,
      },
      {
        accessorKey: "internal_Id",
        header: "Internal ID",
        size: 150,
      },
      {
        accessorKey: "isActive",
        header: "Account Activated",
        size: 120,
        Cell: ({ cell }) => (
          <span className={`badge ${cell.getValue() ? 'badge-success' : 'badge-secondary'}`}>
            {cell.getValue() ? 'Active' : 'Inactive'}
          </span>
        ),
      },
    ],
    [],
  );

  const rowAction = (event, row) => {
    console.log(event, row);
    dispatch(setCustomer(row.original));
    history(`/app/contact-app/contacts`);
  };

  const handlePageChange = (event) => {
    const newState =
      typeof event === "function"
        ? event({ pageIndex: page, pageSize: pageSize })
        : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: { density: "compact" },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
  });

  // Parse Excel file
  const parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          if (jsonData?.length === 0) {
            reject(new Error("Excel file is empty"));
            return;
          }

          const headers = jsonData[0]
            .map((h) => String(h || "").trim())
            .filter((h) => h);
          const rows = jsonData
            .slice(1)
            .map((row) => {
              const obj = {};
              headers.forEach((header, index) => {
                obj[header] =
                  row[index] !== undefined
                    ? String(row[index] || "").trim()
                    : "";
              });
              return obj;
            })
            .filter((row) => Object.values(row).some((v) => v));

          resolve({ headers, data: rows });
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  // Parse CSV file
  const parseCSVFile = (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        transform: (value) => {
          return typeof value === "string" ? value.trim() : value;
        },
        complete: (results) => {
          if (results?.errors?.length > 0 && results?.data?.length === 0) {
            reject(new Error("Error parsing CSV file"));
            return;
          }
          const headers = Object.keys(results.data[0] || {});
          resolve({ headers, data: results.data });
        },
        error: reject,
      });
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file size
    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size should be less than 5MB");
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
      return;
    }

    // Validate file type
    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
    const isExcel =
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.name.endsWith(".xlsx") ||
      file.name.endsWith(".xls");

    if (!isCSV && !isExcel) {
      toast.error(
        "Please upload a valid CSV or Excel file (.csv, .xlsx, .xls)",
      );
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
      return;
    }

    try {
      setCsv(file);
      setError(null);

      // Parse file to get headers
      let result;
      if (isCSV) {
        result = await parseCSVFile(file);
      } else {
        result = await parseExcelFile(file);
      }

      if (result?.data?.length > 1001) {
        toast.error("Please upload a file with less than 1000 records.");
        if (inputRef.current) inputRef.current.value = "";
        setCsv(null);
        return;
      }

      // Set uploaded headers
      setUploadedHeaders(result.headers);

      // Initialize mapping with empty values (database field -> uploaded header)
      const initialMapping = {};
      CUSTOMER_FIELDS.forEach((field) => {
        if (
          /**Checking the Field Name */
          result?.headers?.includes(field.key)
        ) {
          initialMapping[field?.key] = field?.key;
        } else {
          initialMapping[field.key] = "";
        }
      });
      setFieldMapping(initialMapping);
      setMappingErrors({});

      // Show mapping modal
      setShowMappingModal(true);
    } catch (error) {
      toast.error(`Error parsing file: ${error.message}`);
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
    }
  };

  // Get sorted customer fields (required first)
  const getSortedCustomerFields = () => {
    const requiredFields = CUSTOMER_FIELDS.filter((field) => field.required);
    const optionalFields = CUSTOMER_FIELDS.filter((field) => !field.required);
    return [...requiredFields, ...optionalFields];
  };

  // Get available uploaded headers for a specific database field.
  // Excludes headers that are already mapped to OTHER database fields,
  // but keeps the header currently selected for this field so user can see/change it.
  const getAvailableUploadedHeaders = (currentDatabaseField) => {
    const currentMappedHeader = fieldMapping[currentDatabaseField] || "";

    // All headers that are mapped somewhere (any DB field)
    const allMappedHeaders = Object.entries(fieldMapping)
      .filter(([_, header]) => header) // non-empty
      .map(([_, header]) => header);

    return uploadedHeaders.filter((header) => {
      if (header === currentMappedHeader) {
        // Always keep the one currently selected for this field
        return true;
      }
      // Otherwise, hide it if it's already used by some other field
      return !allMappedHeaders.includes(header);
    });
  };

  // Handle mapping change (database field -> uploaded header)
  const handleMappingChange = (databaseField, uploadedHeader) => {
    setFieldMapping((prev) => ({
      ...prev,
      [databaseField]: uploadedHeader,
    }));

    // Clear error for this field
    if (mappingErrors[databaseField]) {
      setMappingErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[databaseField];
        return newErrors;
      });
    }
  };

  // Validate mapping before upload
  const validateMapping = () => {
    const errors = {};
    const requiredFields = CUSTOMER_FIELDS.filter((field) => field.required);

    // Check if all required fields are mapped
    requiredFields.forEach((field) => {
      const mappedUploadedHeader = fieldMapping[field.key];
      if (!mappedUploadedHeader || mappedUploadedHeader === "") {
        errors[field.key] = `${field.label} is required but not mapped`;
      }
    });

    setMappingErrors(errors);
    return Object?.keys(errors)?.length === 0;
  };

  // Handle final upload
  const handleFinalUpload = async () => {
    if (!validateMapping()) {
      toast.error("Please map all required fields before uploading.");
      return;
    }

    if (!csv) {
      toast.error("No file selected.");
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("files", csv);
      formData.append("mappingJson", JSON.stringify(fieldMapping)); // { dbFieldKey: uploadedHeader }

      const response = await axios.post(
        `${process.env.REACT_APP_PL_API}/customers/bulkupload_user-new`,
        formData,
        {
          headers: {
            "x-tenant-id": client,
            // "Content-Type": "application/json",
            "x-access-token": getAccessToken(client),
          },
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
          // timeout: 5 * 60 * 1000, // g
          responseType: "blob",
        },
      );

      saveAs(response.data, "upload_result.csv");
      setCsv(null);
      setShowMappingModal(false);
      setFieldMapping({});
      setUploadedHeaders([]);
      if (inputRef.current) inputRef.current.value = "";
      toast.success("File uploaded and result downloaded successfully");

      // Refresh customer list
      getCustomers();
    } catch (error) {
      toast.error(`Error uploading file: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Close mapping modal
  const handleCloseMappingModal = () => {
    setShowMappingModal(false);
    setCsv(null);
    setFieldMapping({});
    setUploadedHeaders([]);
    setMappingErrors({});
    setIsPreview(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  /***
   * Get Template Download
   */
  const handleDownloadTemplate = () => {
    setIsTemplateDownloadLoading(true);
    try {
      const csvContent = CUSTOMER_FIELDS?.map((el) => el?.key).join(","); // <--- your CSV string
      const filename = "Get-Template.csv";
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
      saveAs(blob, filename);
    } catch {
    } finally {
      setIsTemplateDownloadLoading(false);
    }
  };

  const handlePreview = () => {
    setIsPreview(true);
  };
  const handlePreviewBack = () => {
    setIsPreview(false);
  };

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Customers"
        parent="Customers"
        parentPath="customers"
        title="Customers List"
      />

      <Container fluid={true}>
        {UploadAllowTenant?.includes(
          tenantClientData?.selectedClient?.value,
        ) && (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label for="csvFile">Upload CSV</Label>
                      <Input
                        type="file"
                        id="csvFile"
                        accept=".csv,.xlsx,.xls"
                        onChange={handleFileChange}
                        innerRef={inputRef}
                      />
                      <small className="form-text text-muted">
                        Supported formats: CSV. Max file size: 5MB. Max records:
                        1000.
                      </small>
                    </FormGroup>
                    {error && <Alert color="danger">{error}</Alert>}
                    {success && <Alert color="success">{success}</Alert>}

                    <Button color="info" onClick={handleDownloadTemplate}>
                      {isTemplateDownloadLoading
                        ? "Downloading..."
                        : "Get Template"}
                    </Button>
                    <Button
                      color="outline-secondary"
                      onClick={() => setProgramSlugOpen(true)}
                      title="View program slug names"
                    >
                      📋 Programs &amp; Slugs
                    </Button>
                    <ProgramSlugModal
                      isOpen={programSlugOpen}
                      toggle={() => setProgramSlugOpen(false)}
                    />
                    {SlugNameAllowTenant.includes(client) && (
                      <Button
                        color="primary"
                        style={{ marginLeft: 8 }}
                        onClick={async () => {
                          try {
                            // Pass tenantId and accessToken in payload for backend header mapping
                            const res = await dispatch(getAllPrograms({
                              getBySlugName: true,
                              tenantId: client,
                              accessToken: getAccessToken(client),
                            }));
                            const data = res?.payload || [];
                            const list = Array.isArray(data)
                              ? data
                                .map((p) => ({
                                  name: p.name || "",
                                  slug: p.slug_name || p.slug || ""
                                }))
                                .filter((p) => p.name && p.slug)
                              : [];
                            setProgramList(list);
                            setShowSlugModal(true);
                          } catch (err) {
                            setProgramList([]);
                            setShowSlugModal(true);
                          }
                        }}
                      >
                        View Program Slug Names
                      </Button>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

        {/* Field Mapping Modal showMappingModal*/}
        <Modal
          isOpen={showSlugModal}
          toggle={() => setShowSlugModal(false)}
          size="xl"
        >
          <ModalHeader toggle={() => setShowSlugModal(false)}>
            Program Name & Slug Names
          </ModalHeader>
          <ModalBody style={{ minHeight: "460px" }}>
            <PaginatedProgramTable programList={programList || []} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setShowSlugModal(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={showMappingModal}
          toggle={handleCloseMappingModal}
          size="xl"
        >
          <ModalHeader toggle={handleCloseMappingModal}>
            {isPreview ? "View Preview" : "Map Fields to Database"}
          </ModalHeader>
          {isPreview ? (
            <ModalBody>
              <div style={{ height: "250px" }}></div>
              {/* <MaterialReactTable table={table} /> */}
            </ModalBody>
          ) : (
            <ModalBody>
              <Alert color="info" className="bg-primary bg-opacity-25">
                Please select which column from your uploaded file maps to each
                database field. Required fields are marked with{" "}
                <span className="text-danger">*</span> and must be mapped.
              </Alert>

              <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Database Field</th>
                      <th>Select Uploaded Field</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getSortedCustomerFields().map((field) => {
                      const mappedUploadedHeader =
                        fieldMapping[field.key] || "";
                      const isRequired = field.required || false;
                      const isMapped = mappedUploadedHeader !== "";
                      const hasError = mappingErrors[field.key];

                      return (
                        <tr
                          key={field.key}
                          style={
                            isRequired ? { backgroundColor: "#fff5f5" } : {}
                          }
                        >
                          <td>
                            <strong>
                              {field.label}
                              {isRequired && (
                                <span className="text-danger ml-1">*</span>
                              )}
                            </strong>
                            <br />
                            <small className="text-muted">({field.key})</small>
                          </td>
                          <td>
                            <Input
                              type="select"
                              value={mappedUploadedHeader}
                              onChange={(e) =>
                                handleMappingChange(field.key, e.target.value)
                              }
                              className={
                                hasError || (isRequired && !isMapped)
                                  ? "border-danger"
                                  : ""
                              }
                            >
                              <option value="">
                                -- Select Uploaded Field --
                              </option>
                              {getAvailableUploadedHeaders?.(field?.key)?.map(
                                (header) => (
                                  <option key={header} value={header}>
                                    {header}
                                  </option>
                                ),
                              )}
                            </Input>
                            {hasError && (
                              <small className="text-danger d-block mt-1">
                                {mappingErrors[field.key]}
                              </small>
                            )}
                          </td>
                          <td>
                            {isRequired ? (
                              <span
                                className={`badge ${isMapped ? "badge-success" : "badge-danger"}`}
                              >
                                {isMapped ? "Mapped" : "Required"}
                              </span>
                            ) : (
                              <span
                                className={`badge ${isMapped ? "badge-info" : "badge-secondary"}`}
                              >
                                {isMapped ? "Mapped" : "Optional"}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {Object?.keys(mappingErrors)?.length > 0 && (
                <Alert color="danger">
                  <strong>Mapping Errors:</strong>
                  <ul className="mb-0">
                    {Object?.values(mappingErrors)?.map((error, idx) => (
                      <li key={idx}>{error}</li>
                    ))}
                  </ul>
                </Alert>
              )}
            </ModalBody>
          )}

          <ModalFooter>
            {isPreview && (
              <Button
                outline
                color="primary"
                disabled={isLoading}
                onClick={handlePreviewBack}
                style={{ marginRight: "auto" }}
              >
                Previous
              </Button>
            )}

            <Button
              color="secondary"
              disabled={isLoading}
              onClick={handleCloseMappingModal}
            >
              Cancel
            </Button>

            {/* {
              isPreview ? ( */}
            <Button
              color="primary"
              disabled={isLoading}
              onClick={handleFinalUpload}
            >
              {isLoading ? "Uploading..." : "Upload with Mapping"}
            </Button>
            {
              //   ) : (
              //   <Button color="primary" disabled={isLoading} onClick={handlePreview}>
              //     View Preview
              //   </Button>
              //   )
            }
          </ModalFooter>
        </Modal>

        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <FormGroup>
                  <Label for="csvFile">Upload CSV File</Label>
                  <Input
                    type="file"
                    id="csvFile"
                    accept=".csv"
                    onChange={handleFileChange}
                    innerRef={inputRef}
                  />
                </FormGroup>
                {error && <Alert color="danger">{error}</Alert>}
                {success && <Alert color="success">{success}</Alert>}

                {/* Action Buttons */}
                <div className="d-flex gap-2 mt-2">
                  {/* Download Format Button */}
                  <Button
                    color="secondary"
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = "/excel/Get-Template.csv"; // file in public folder
                      link.download = "/excel/Get-Template.csv";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    Download CSV Format
                  </Button>

                  {/* Upload Button (if needed later) */}
                  {/* 
                  <Button color="primary" onClick={handleCSVUpload}>
                    Upload CSV
                  </Button> 
                  */}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};


// Program table with built-in Material React Table pagination
const PaginatedProgramTable = ({ programList }) => {
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Program Name",
      },
      {
        accessorKey: "slug",
        header: "Slug Name",
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: programList,
    initialState: {
      density: "compact",
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    enableSorting: false,
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableRowActions: false,
    enableTopToolbar: false,
    enableBottomToolbar: true,
    muiTableContainerProps: {
      sx: { minHeight: "340px" },
    },
  });

  return (
    <MaterialReactTable table={table} />
  );
};

export default CustomersTable;
